import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  #thirdPartyInventoryObserver;

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#applyVisibilityRule();
    this.#thirdPartyInventoryObserver = new MutationObserver(this.#applyThirdPartyVisibilityRule);
    this.#thirdPartyInventoryObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    this.#applyThirdPartyVisibilityRule();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#thirdPartyInventoryObserver?.disconnect();
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #applyVisibilityRule = () => {
    const status = this.querySelector('.product-inventory__status');
    const isOutOfStock = this.querySelector('.product-inventory__icon-out_of_stock');

    if (!status) {
      this.hidden = true;
      return;
    }

    if (isOutOfStock) {
      this.hidden = false;
      return;
    }

    const text = this.querySelector('.product-inventory__text')?.textContent ?? '';
    const match = text.replace(/,/g, '').match(/\d+/);
    this.hidden = !match || Number(match[0]) > 9;
  };

  #applyThirdPartyVisibilityRule = () => {
    document.querySelectorAll('.hengam-low-stock-description').forEach((element) => {
      const match = element.textContent?.replace(/,/g, '').match(/\d+/);
      element.hidden = !match || Number(match[0]) > 9;
    });
  };

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
        this.#applyVisibilityRule();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
